module.exports = __webpack_public_path__ + "assets/img/noAddCard.b2cb4702.png";